import React, { useState, useEffect } from 'react';
import { Input, Modal, Button, Card, Tabs, Row, Col, Tooltip, Popconfirm, AutoComplete, Checkbox, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import '../../MyProfile/profile.css';

const TabPane = Tabs.TabPane;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const FormItem = Form.Item;

let personGUID = '';

const BusinessForm = (props) => {
    const [state, setState] = useState({
        forceRender: true,
        isInEditMode: false,
        defaultActiveKey: ['1'],
        firstName: '',
        middleName: '',
        lastName: '',
        nickName: '',
        dateOfBirth: '',
        gender: '',
        BusinessCountry: '616',
        BusinessCountrySelected: '',
        AddressLine1: '',
        City: '',
        State: '',
        ZIPcode: '',
        addressid: '',
        isPrimary: '',
        SelectedStateId: '',
        personGUID: '',
        changedStateID: '',
        IsBusinessCountrySelected: false,
        Business: [],
    });

    const userType = props.by;
    // The userType === 'admin' condition has been set on the Maintain Alumni page to access the address information of alumni by admin.
    // userType === 'alumni' has set in My-profile page to access the address information of the logged-in user.

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const handleSelect = (value, input) => {
        setState({ ...state, gender: input.props.children });
    };

    const states = () => {
        if (props.allstates) {
            let statesarray = props.allstates;
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.id}>
                        {k.short}
                    </option>
                );
            });
        }
    };

    const countries = () => {
        if (props.countries) {
            let countriesarray = props.countries.sort((a, b) => a.name - b.name);
            return countriesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>
                        {k.name}
                    </option>
                );
            });
        }
    };

    const addresstypes = () => {
        if (props.types) {
            let typesarray = props.types;
            return typesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>
                        {k.name}
                    </option>
                );
            });
        }
    };

    useEffect(() => {
        props.actions.getStates();
        props.actions.getCountries();
    }, []);

    const setPrimary = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let stateValue = state.changedStateID !== '' ? state.changedStateID : state.SelectedStateId;
                setState({
                    ...state,
                    State: stateValue,
                });
                props.actions.updateMyAddress(personGUID, state.addressid, values, stateValue, '64', true, userType );
            }
        });
    };

    const handleSubmitBusiness = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let stateValue = state.changedStateID !== '' ? state.changedStateID : state.SelectedStateId;
                setState({
                    ...state,
                    State: stateValue,
                });
                props.actions.updateMyAddress(personGUID, state.addressid, values, stateValue, '64', state.isPrimary, userType );
            }
        });
    };

    const cancelActions = () => {
        if (userType === 'admin' ) {
            props.actions.getAlumniInfo(personGUID, userType);
        } else if (userType === 'alumni' ) {
            props.actions.getProfileInfo(personGUID, userType);
        }
    };

    const handleBusinessChange = (value) => {
        setState({
            ...state,
            BusinessCountrySelected: value,
            IsBusinessCountrySelected: true,
        });
    };

    const BusinessAddressSearch = (value) => {
        if (state.BusinessCountry === '616' || state.BusinessCountrySelected === '616') {
            if (value.length > 3) {
                props.actions.getHomeAddress(value);
            }
        }
    };

    const renderMelissaAddress = () => {
        if (props.BusinessAddress) {
            return props.BusinessAddress.Results.map((data) => data.Address.AddressLine1);
        }
    };

    const BusinessAddressonSelect = (e) => {
        let selected = props.BusinessAddress.Results.find((data) => data.Address.AddressLine1 === e);
        setState({
            ...state,
            AddressLine1: selected.Address.AddressLine1,
            City: selected.Address.City,
            State: selected.Address.State,
            ZIPcode: selected.Address.PostalCode.substring(0, 5),
        });
        let selectedState = props.allstates.find((data) => data.short === selected.Address.State);
        setState({
            ...state,
            changedStateID: selectedState.id,
        });
    };

    const handleStateChange = (e) => {
        setState({
            ...state,
            changedStateID: e,
        });
    };

    const render_USA_address = (Business) => {
        const { getFieldDecorator } = props.form;

        return (
            <Row type="flex" align="middle" justify="start">
                
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="Country"
                    >
                        {getFieldDecorator(`country`, {
                            initialValue: Business ? Business.countryId : "616",
                            rules: [{ required: true, message: 'Select Alumni\'s Country!' }],
                        })(
                            <Select
                                onChange={handleBusinessChange}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Country"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {countries()}
                            </Select>
                        )}
                    </FormItem>
                </Col>
                
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="Address Line 1"
                    >
                        {getFieldDecorator('addressline1', {
                            initialValue: Business ? Business.address1 : "",
                            rules: [
                                { required: true, message: 'Enter Address Line 1!' },
                                { max: 100, message: 'Address Line 1 must be maximum 100 characters.' },
                            ],
                        })(
                            <AutoComplete
                                dataSource={(state.BusinessCountry == '616' || state.BusinessCountrySelected == '616') ? renderMelissaAddress() : []}
                                style={{ width: '100%' }}
                                onSelect={BusinessAddressonSelect}
                                onSearch={BusinessAddressSearch}
                                placeholder="Address Line 1"
                            />
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="Address Line 2"
                    >
                        {getFieldDecorator('addressline2', {
                            initialValue: Business ? Business.address2 : "",
                            rules: [
                                { required: false, message: 'Enter Address Line 2!' },
                                { max: 100, message: 'Address Line 2 must be maximum 100 characters.' },
                            ],
                        })(
                            <Input placeholder="Address Line 2" />
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="City"
                    >
                        {getFieldDecorator('city', {
                            initialValue: state.City ? state.City : (Business ? Business.city : ""),
                            rules: [
                                { required: true, message: 'Enter Alumni\'s City!' },
                                { max: 100, message: 'City must be maximum 100 characters.' },
                            ],
                        })(
                            <Input placeholder="City" />
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="State"
                    >
                        {getFieldDecorator('state', {
                            initialValue: state.State ? state.State : (Business ? Business.stateId : ""),
                            rules: [{ required: true, message: 'Enter Alumni\'s State!' }],
                        })(
                            <Select
                                onChange={handleStateChange}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a State"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {states()}
                            </Select>
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="ZIP Code"
                    >
                        {getFieldDecorator('zipcode', {
                            initialValue: state.ZIPcode ? state.ZIPcode : (Business ? Business.zipCode : ""),
                            rules: [{ required: true, max: 5, min: 5, message: 'Enter Alumni\'s ZIP Code!' }],
                        })(
                            <Input placeholder="ZIP Code" />
                        )}
                    </FormItem>
                </Col>

            </Row>
        );
    };

    const render_nonUSA_address = (Business) => {
        const { getFieldDecorator } = props.form;

        return (
            <Row type="flex" align="middle" justify="start">
                
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label="Country"
                    >
                        {getFieldDecorator(`country`, {
                            initialValue: Business ? Business.countryId : "616",
                            rules: [{ required: true, message: 'Select Alumni\'s Country!' }],
                        })(
                            <Select
                                onChange={handleBusinessChange}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Country"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {countries()}
                            </Select>
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        label={(
                            <span>
                                Address Line 1&nbsp;
                            <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                    >
                        {getFieldDecorator('addressline1', {
                            initialValue: Business ? Business.address1 : "",
                            rules: [
                                { required: true, message: 'Enter Address Line 1!' },
                                { max: 100, message: 'Address Line 1 must be maximum 100 characters.' },
                            ],
                        })(
                            <AutoComplete
                                dataSource={(state.BusinessCountry == '616' || state.BusinessCountrySelected == '616') ? renderMelissaAddress() : []}
                                style={{ width: '100%' }}
                                onSelect={BusinessAddressonSelect}
                                onSearch={BusinessAddressSearch}
                                placeholder="Address Line 1"
                            />
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        style={{ marginBottom: '0px' }}
                        label={(
                            <span>
                                Address Line 2&nbsp;
                            <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                    //extra="City, Territory, Postal Code, Country"
                    >
                        {getFieldDecorator('addressline2', {
                            initialValue: Business ? Business.address2 : "",
                            rules: [
                                { required: false, message: 'Enter Address Line 2!' },
                                { max: 100, message: 'Address Line 2 must be maximum 100 characters.' },
                            ],
                        })(
                            <Input placeholder="Address Line 2" />
                        )}
                    </FormItem>
                </Col>
    
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <FormItem hasFeedback
                        style={{ marginBottom: '0px' }}
                        label={(
                            <span>
                                Address Line 3&nbsp;
                                 <Tooltip placement="top" title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver, BC V5X 2H6">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                        extra="City, Territory, Postal Code, Country"
                    >
                        {getFieldDecorator('addressline3', {
                            initialValue: Business ? Business.address3 : "",
                            rules: [
                                { required: true, message: 'Enter Address Line 3!' },
                                { max: 100, message: 'Address Line 3 must be maximum 100 characters.' },
                            ],
                        })(
                            <Input placeholder="Address Line 3" />
                        )}
                    </FormItem>
                </Col>

            </Row>
        );
    };

    const renderAddress = (profileinfo) => {
        const { getFieldDecorator } = props.form;
        const address = profileinfo.addresses;
        const types = props.types;
        let Business = '';
        personGUID = profileinfo.profile.personGuid;
        if (props.types) {
            address.map((k, index) => {
                if (k.typeId === '64') {
                    Business = k;
                    if (state.addressid === '') {
                        setState({
                            ...state,
                            addressid: Business.id,
                            BusinessCountry: Business.countryId,
                            SelectedStateId: Business.stateId,
                        });
                    }
                    if (state.isPrimary === '') {
                        setState({
                            ...state,
                            isPrimary: Business.isPrimary,
                        });
                    }
                }
            });
        }

        return (
            <Form onSubmit={handleSubmitBusiness} className="alumni-ui address-form">
                {((state.IsBusinessCountrySelected === false && state.BusinessCountry === '616') ||
                    (state.IsBusinessCountrySelected === true && state.BusinessCountrySelected !== '' && state.BusinessCountrySelected === '616')) ? 
                    (render_USA_address(Business)) : (render_nonUSA_address(Business))
                }

                <Row type="flex" className="btn-action" align="bottom" justify="space-between">
                    
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                        <FormItem>
                            <Button id="maintainpfle-hm-ad-cl-btn" className="myprofile-cancel-btn" onClick={() => cancelActions()}>CANCEL</Button>
                        </FormItem>
                    </Col>

                    {Business ? Business.isPrimary == 'False' &&
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <FormItem>
                                    <Button id="maintainpfle-hm-ad-cl-btn" className="save-change-btn" onClick={setPrimary.bind()} type="success">SET PRIMARY</Button>
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <FormItem>
                                    <Popconfirm placement="top" title="Are you sure to delete this address?" onConfirm={() => {
                                        setState({
                                          ...state,
                                            AddressLine1: "",
                                            City: "",
                                            State: "",
                                            ZIPcode: "",
                                            addressid: ""
                                        }), 
                                            props.actions.deleteaddress(personGUID, Business.id, userType )
                                    }} okText="Yes" cancelText="No">
                                        <Button className="save-change-btn" type="danger">CLEAR ADDRESS</Button>
                                    </Popconfirm>
                                </FormItem>
                            </Col>

                        </Col>
                    : ""}

                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                        <FormItem>
                            <Button htmlType='submit' id="maintainpfle-hm-ad-sb-btn" className="save-change-btn" type="primary">SAVE CHANGES</Button>
                        </FormItem>
                    </Col>

                </Row>
            </Form>
        );
    };

    const renderBusinessAddress = () => {
        let profileInfo, loading;
        if(userType === 'admin' && props.alumniProfileinfo) profileInfo = props.alumniProfileinfo; // The userType === 'admin' condition has been set on the Maintain Alumni page to access the address information of alumni by admin.
        if(userType === 'admin') loading = props.alumniProfileLoading;
        if(userType != 'admin' && props.profileinfo) profileInfo = props.profileinfo; // userType === 'alumni' has set in My-profile page to access the address information of the logged-in user.

        if (props.updating) {
            return <Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Updating Information..." />;
        } else if (loading) {
            return <Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Loading Information..." />;
        } else if (profileInfo) {
            return renderAddress(profileInfo);
        } else {
            return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />;
        }
    };

    return renderBusinessAddress();
};

function mapStateToProps(state) {
    return {
        loading: state.profilereducer.loading,
        profileinfo: state.profilereducer.profileinfo,

        alumniProfileLoading: state.alumniinforeducer.loading,
        alumniProfileinfo: state.alumniinforeducer.profileinfo,
        allstates: state.allstatesreducer.states,
        countries: state.countriesreducer.countries,
        types: state.addresstypesreducer.types,
        Addressloading: state.homeaddressreducer.loading,
        HomeAddress: state.homeaddressreducer.address,
        updating: state.updatemyaddressreducer.loading,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

const Business_Address = Form.create()(BusinessForm);

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Business_Address);



// WEBPACK FOOTER //
// ./src/components/Inc/Address.js/Business_Address.js